import { ContactInfoConfig, DEFAULT_CONTACT_INFO_CONFIG } from './ContactInfo';
import { TopicTypeConfig } from './TopicTypeItem';
import { InputsConfig } from './InputItem';

export type SubscriptionCardConfigItemV1 = Readonly<{
  version: 'v1';
  id: string | null;
  name: string;
  eventTypes: TopicTypeConfig;
  inputs: InputsConfig;
  contactInfo: ContactInfoConfig;
  titles: TitleSubtitleConfig;
  isContactInfoRequired: boolean;
  walletChain: string;
}>;

export type TitleSubtitleConfigInactive = Readonly<{ active: false }>;

export type TitleSubtitleConfigActive = Readonly<{
  active: true;
  editView: string;
  previewView: string;
  historyView: string;
  signupView: string;
  expiredView: string;
  alertDetailsView: string;
  verifyWalletsView: string;
}>;

export type TitleSubtitleConfig =
  | TitleSubtitleConfigActive
  | TitleSubtitleConfigInactive;

export type CardVersion = SubscriptionCardConfigItemV1['version'];

export const createSubscriptionDefault = (
  name: string,
): SubscriptionCardConfigItemV1 => {
  return {
    version: 'v1',
    id: null,
    name,
    eventTypes: [],
    inputs: [],
    contactInfo: DEFAULT_CONTACT_INFO_CONFIG,
    titles: { active: false },
    isContactInfoRequired: true,
    walletChain: '',
  };
};
